// src/features/fourlink-config/components/shared/CommentButton.jsx

import React, { useState } from 'react';
import { ChecklistModal } from './ChecklistModal';
import { useChecklists } from '../../hooks/useChecklists';

const MessageIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className}>
    <path
      d="M4 5h16a1 1 0 011 1v9a1 1 0 01-1 1H8l-4 3V6a1 1 0 011-1z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CommentButton = ({
  onClick,
  hasComment,
  srLabel,
  checklistIds,
  count = 0,
  className = '',
  variant = 'default', // 'default' | 'small' | 'circle'
}) => {
  const isChecklistMode = Boolean(
    checklistIds && (!Array.isArray(checklistIds) || checklistIds.length > 0),
  );

  const [isModalOpen, setIsModalOpen] = useState(false);
  const {
    loadChecklist,
    getChecklistFromCache,
    isChecklistLoading,
    getChecklistError,
  } = useChecklists();

  const handleChecklistClick = async () => {
    setIsModalOpen(true);

    if (!getChecklistFromCache(checklistIds)) {
      await loadChecklist(checklistIds);
    }
  };

  if (!isChecklistMode && typeof onClick !== 'function') {
    return null;
  }

  const checklistData = isChecklistMode ? getChecklistFromCache(checklistIds) : null;
  const isLoading = isChecklistMode ? isChecklistLoading(checklistIds) : false;
  const error = isChecklistMode ? getChecklistError(checklistIds) : null;

  const baseClasses = (() => {
    if (variant === 'small') return 'p-1 text-xs';
    if (variant === 'circle') return 'w-10 h-10 p-0 flex items-center justify-center text-base';
    return 'px-3 py-1.5 text-sm';
  })();

  const colorClasses =
    variant === 'circle'
      ? hasComment || count > 0
        ? 'border border-blue-400 text-blue-700 bg-white hover:bg-blue-50'
        : 'border border-gray-200 text-gray-600 bg-white hover:bg-gray-50'
      : hasComment || count > 0
      ? 'bg-blue-100 text-blue-700 hover:bg-blue-200'
      : 'bg-gray-100 text-gray-600 hover:bg-gray-200';

  const buttonClasses = `
    inline-flex items-center gap-1.5 rounded-lg font-medium
    transition-all duration-200
    ${colorClasses}
    ${baseClasses}
    ${className}
  `;

  return (
    <>
      <button
        onClick={isChecklistMode ? handleChecklistClick : onClick}
        className={buttonClasses}
        title={isChecklistMode ? 'Ver checklist' : 'Añadir comentario'}
        type="button"
        aria-label={srLabel}
      >
        <MessageIcon className={variant === 'small' ? 'h-3 w-3' : 'h-4 w-4'} />
        {(count > 0 || hasComment) && <span>{count > 0 ? count : '•'}</span>}
      </button>

      {isChecklistMode && (
        <ChecklistModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          checklistData={checklistData}
          isLoading={isLoading}
          error={error}
        />
      )}
    </>
  );
};
